import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class BookingUnlockedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(
    public readonly bookingId: string,
    public readonly success: boolean) {
  }
}
